(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["web-tour"] && !Shopify.designMode) return;
  try {
    
  const tabParamKey = 'tab';
  const stickyHeaderSelector = '[data-web-tour-sticky-header]';
  const stickyHeaderStuckClass = 'is-stuck';
  const stickyHeaderSentinelClass = 'web-tour-sticky-header-sentinel';
  const stickyHeaderNavItemSelector = '.web-tour-sticky-header__nav-item';
  // Link selector is shared across desktop and mobile; desktop is scoped by container check.
  const stickyHeaderNavLinkSelector = 'a[data-tab-target]';
  const tabPanelSelector = '.web-tour-tab-panel';
  const desktopNavSelector = '.web-tour-sticky-header__nav';
  const mobileMenuSelector = '.web-tour-sticky-header__mobile-menu';
  const wrapperSelector = '.web-tour-wrapper';
  const unresolvedPurchaseCtaSelector = 'a[href^="#resolve-cta-"]';
  const buttonShortcodesParsedEvent = 'button-shortcodes:parsed';
  const anchor_target_selector = `${tabPanelSelector}:not([hidden]) > :is(section, .section, .comp-a-plus-content)[id]`;
  const activeDesktopNavButtonClasses = ['active'];
  let stickyHeaderHeightObserver = null;
  let stickyHeaderStateObserver = null;

  /**
   * Sticky header setup:
   * - Keep --web-tour-sticky-header-height in sync via ResizeObserver.
   * - Toggle .is-stuck once a small sentinel above the header leaves the viewport.
   */
  const initWebTourStickyHeader = () => {
    const wrapper = getWebTourWrapper();
    if (!(wrapper instanceof HTMLElement)) return;

    const header = wrapper.querySelector(stickyHeaderSelector);
    if (!header) return;

    const updateHeaderHeight = () => {
      wrapper.style.setProperty('--web-tour-sticky-header-height', `${header.offsetHeight}px`);
    };

    if (stickyHeaderHeightObserver) {
      stickyHeaderHeightObserver.disconnect();
    }

    stickyHeaderHeightObserver = new ResizeObserver(updateHeaderHeight);
    stickyHeaderHeightObserver.observe(header);
    updateHeaderHeight();

    if (!('IntersectionObserver' in window)) return;

    let sentinel = wrapper.querySelector(`.${stickyHeaderSentinelClass}`);
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.className = stickyHeaderSentinelClass;
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.height = '1px';
      sentinel.style.pointerEvents = 'none';
      header.parentNode.insertBefore(sentinel, header);
    }

    if (stickyHeaderStateObserver) {
      stickyHeaderStateObserver.disconnect();
    }

    stickyHeaderStateObserver = new IntersectionObserver(([entry]) => {
      header.classList.toggle(stickyHeaderStuckClass, !entry.isIntersecting);
    });

    stickyHeaderStateObserver.observe(sentinel);
  };

  const getFallbackTabKey = (navLinks) => {
    if (!navLinks.length) return null;
    return navLinks[0].dataset.tabTarget || null;
  };

  const getWebTourWrapper = () => document.querySelector(wrapperSelector);

  /**
   * Resolve migrated purchase CTA placeholders for retail-only product pages.
   * The marker may come from a server-rendered metaobject link or an RTE shortcode.
   */
  const resolveRetailOnlyPurchaseCtas = () => {
    const wrapper = getWebTourWrapper();
    if (!(wrapper instanceof HTMLElement)) return;
    if (wrapper.dataset.retailOnlyProduct !== 'true') return;

    const retailerUrl = wrapper.dataset.retailerCtaUrl;
    const retailerLabel = wrapper.dataset.retailerCtaLabel;
    if (!retailerUrl || !retailerLabel) return;

    for (const link of wrapper.querySelectorAll(unresolvedPurchaseCtaSelector)) {
      link.setAttribute('href', retailerUrl);
      link.textContent = retailerLabel;
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.removeAttribute('title');

      if (link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', retailerLabel);
      }
    }
  };

  // On tab switch we always reset to the top of the Web Tour section.
  const scrollToWebTourTop = (behavior = 'auto') => {
    const wrapper = getWebTourWrapper();
    if (!(wrapper instanceof HTMLElement)) return;

    const wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: Math.max(0, wrapperTop), behavior });
  };

  const setActiveTab = (requestedTab = null) => {
    const params = new URLSearchParams(window.location.search);
    const activeTab = requestedTab || params.get(tabParamKey);

    const navItems = document.querySelectorAll(stickyHeaderNavItemSelector);
    const navLinks = document.querySelectorAll(
      `${stickyHeaderNavItemSelector} ${stickyHeaderNavLinkSelector}`
    );
    const panels = document.querySelectorAll(tabPanelSelector);

    // Determine which tab key is active (fallback: first nav item's tab)
    let activeKey = activeTab;

    if (!activeKey) {
      activeKey = getFallbackTabKey(navLinks);
    }

    // Without a valid key we keep server-rendered defaults (first panel visible).
    if (!activeKey) {
      return;
    }

    // Update nav items
    for (const item of navItems) {
      const link = item.querySelector('a');
      if (!link) continue;

      const linkTab = link.dataset.tabTarget;
      const isActive = linkTab === activeKey;
      item.classList.toggle('active', isActive);
      link.setAttribute('aria-current', isActive ? 'page' : 'false');

      const isDesktopNavButton = item.closest(desktopNavSelector);

      if (!isDesktopNavButton) continue;

      for (const class_name of activeDesktopNavButtonClasses) {
        link.classList.toggle(class_name, isActive);
      }
    }

    // Update panels
    let hasMatch = false;
    for (const panel of panels) {
      const isActive = panel.dataset.tab === activeKey;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', (!isActive).toString());
      hasMatch = hasMatch || isActive;
    }

    if (!hasMatch) {
      const fallbackKey = getFallbackTabKey(navLinks);
      if (fallbackKey && fallbackKey !== activeKey) {
        setActiveTab(fallbackKey);
      }
    }
  };

  const getHashTarget = () => {
    const hash = window.location.hash;
    if (!hash || hash.length <= 1) return null;

    const target_id = decodeURIComponent(hash.slice(1));
    if (!target_id) return null;

    const target = document.getElementById(target_id);
    if (!(target instanceof HTMLElement)) return null;

    if (!target.matches(anchor_target_selector)) return null;
    return target;
  };

  // Re-align hash target when sticky header exists in web-tour.
  const alignHashTargetAfterLayout = (behavior = 'instant') => {
    const wrapper = getWebTourWrapper();
    if (!(wrapper instanceof HTMLElement)) return;

    const stickyHeader = wrapper.querySelector(stickyHeaderSelector);
    if (!(stickyHeader instanceof HTMLElement)) return;

    const target = getHashTarget();
    if (!(target instanceof HTMLElement)) return;

    // Two RAF ticks wait for style/layout flush after tab visibility + sticky height updates.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior, block: 'start' });
      });
    });
  };

  // Retry once for late-loading content that shifts layout on heavy pages.
  const alignHashTargetWithRetry = () => {
    alignHashTargetAfterLayout();
    window.setTimeout(() => alignHashTargetAfterLayout(), 180);
  };

  const updateUrlForTab = (tabKey, { clearAnchor = false } = {}) => {
    if (!tabKey) return;
    const url = new URL(window.location.href);
    url.searchParams.set(tabParamKey, tabKey);
    if (clearAnchor) {
      url.hash = '';
    }
    window.history.pushState({}, '', url);
  };

  const closeMobileMenu = () => {
    const mobileMenu = document.querySelector(mobileMenuSelector);
    if (mobileMenu?.hasAttribute('open')) {
      mobileMenu.removeAttribute('open');
    }
  };

  const bindTabNavigation = () => {
    const navLinks = document.querySelectorAll(
      `${stickyHeaderNavItemSelector} ${stickyHeaderNavLinkSelector}`
    );
    if (!navLinks.length) return;

    for (const link of navLinks) {
      if (link.dataset.webTourTabBound === 'true') continue;
      link.dataset.webTourTabBound = 'true';
      link.addEventListener('click', (event) => {
        const tabKey = link.dataset.tabTarget;
        if (!tabKey) return;

        event.preventDefault();
        setActiveTab(tabKey);
        // Anchors are tab-specific; remove hash when switching tabs.
        updateUrlForTab(tabKey, { clearAnchor: true });
        closeMobileMenu();
        scrollToWebTourTop('smooth');
      });
    }
  };

  // Keep init events centralized to avoid duplicated listener blocks.
  for (const event_name of ['DOMContentLoaded', 'shopify:section:load']) {
    document.addEventListener(event_name, () => {
      initWebTourStickyHeader();
      setActiveTab();
      bindTabNavigation();
      resolveRetailOnlyPurchaseCtas();
      alignHashTargetWithRetry();
    });
  }

  document.addEventListener(buttonShortcodesParsedEvent, resolveRetailOnlyPurchaseCtas);

  window.addEventListener('popstate', () => {
    setActiveTab();
    alignHashTargetWithRetry();
  });


  } catch(e) { console.error(e); }
})();
})();
